export const SEARCH_BLOGS = 'SEARCH_BLOGS';
export const SEARCH_FAIL = 'SEARCH_FAIL';
export const UPDATE_BLOGS = 'UPDATE_BLOGS';
